import {
  Directive,
  HostListener,
  ElementRef,
  OnInit,
  Output,
  EventEmitter,
  AfterViewInit,
  Input,
  OnDestroy,
} from '@angular/core';
import EmblaCarousel, {
  EmblaCarouselType,
  EmblaOptionsType,
} from 'embla-carousel';
import * as _ from 'lodash';
import { interval, Observable, Subject, takeUntil, takeWhile } from 'rxjs';

@Directive({
    selector: '[prCarousel]',
    standalone: false
})
export class EaCarouselDirective implements OnInit, AfterViewInit, OnDestroy {
  @Input('prCarousel') set prCarousel(data) {
    if (!data) return;
    this._data = data;
    setTimeout(() => {
      if (this.embla) {
        this.embla.destroy();
        this.embla = undefined;
        this.createCarouselElem();
      }
    }, 0);
    // if (this.embla) this.createCarouselElem();
  }
  @Input('maxWidth') maxWidth: number;
  @Input('minWidth') minWidth;
  @Input('autoplay') autoplay: boolean = false;
  @Input('autoplayTimer') autoplayTimer: number = 2000;
  @Input('padding') padding = 5;
  @Input('options') extraOptions: Partial<EmblaOptionsType> = {};
  private _data;

  // @Input() prCarousel: boolean;
  private el: any;
  private viewport: any;
  private container: any;
  private embla: EmblaCarouselType;
  private lastSlideIndex;
  private autoplayInterval;
  private sliders;
  private alive = true;

  constructor(private elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.createCarouselElem();
  }

  createCarouselElem() {
    this.container =
      this.el.getElementsByClassName('prCarouselContainer')[0] || this.el;
    this.viewport =
      this.el.getElementsByClassName('embla__viewport')[0] ||
      document.createElement('div');
    if (!this.el.getElementsByClassName('embla__viewport')[0])
      this.container.parentNode.replaceChild(this.viewport, this.container);
    this.viewport.appendChild(this.container);
    this.sliders = this.container.childNodes;

    this.el.style.padding = this.padding || 0;
    this.el.classList.add('embla');
    this.viewport.classList.add(`embla__viewport`);
    this.container.classList.add('embla__container');
    this.sliders.forEach((slider: Element) => {
      if (typeof slider != 'object') return;
      let innerSlider = document.createElement('div');
      if (slider.classList) {
        slider.classList.add('embla__slide');
        innerSlider.classList.add('embla__slide__inner');
        while (slider.childNodes.length > 0) {
          innerSlider.appendChild(slider.childNodes[0]);
        }
        slider.appendChild(innerSlider);
      }
    });
    this.carouselInit();
  }

  carouselInit() {
    let options: Partial<EmblaOptionsType> = Object.assign(this.extraOptions, {
      draggable: true,
      align: 'start',
    });
    let ignoreWidth = false;
    if (!this.maxWidth && !this.minWidth) ignoreWidth = true;
    if (
      (ignoreWidth ||
        (this.maxWidth &&
          !window.matchMedia(`(max-device-width: ${this.maxWidth}px)`)
            .matches) ||
        (this.minWidth &&
          !window.matchMedia(`(min-device-width: ${this.minWidth || 0}px)`)
            .matches)) &&
      this.embla
    ) {
      if (this.extraOptions.axis != 'y') {
        this.container.classList.remove('d-flex');
      }
      this.embla.destroy();
      this.embla = undefined;
    }
    if (
      ignoreWidth ||
      (this.maxWidth &&
        window.matchMedia(`(max-device-width: ${this.maxWidth}px)`).matches) ||
      (this.minWidth &&
        window.matchMedia(`(min-device-width: ${this.minWidth || 0}px)`)
          .matches)
    ) {
      if (this.extraOptions.axis != 'y') {
        this.container.classList.add('d-flex');
      }
      if (!this.embla) this.embla = EmblaCarousel(this.viewport, options);
      if (this.autoplay) this.initAutoplay();
    }
  }

  autoplayRunning = false;
  private onDestroy$ = new Subject<void>();
  initAutoplay() {
    this.lastSlideIndex = this.embla.scrollSnapList().length - 1;
    this.startAutoPlay();
  }

  startAutoPlay() {
    interval(this.autoplayTimer)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(this.nextSlide.bind(this));
  }

  stopAutoPlay() {
    this.onDestroy$.next();
  }

  @HostListener('mouseenter')
  mouseEnter() {
    this.stopAutoPlay();
  }

  @HostListener('mouseleave')
  mouseLeave() {
    this.startAutoPlay();
  }

  nextSlide() {
    if (!this.embla) return;
    if (this.embla.selectedScrollSnap() === this.lastSlideIndex) {
      this.embla.scrollTo(0);
    } else {
      this.embla.scrollNext();
    }
  }

  /* @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.carouselInit()
  } */

  ngOnDestroy() {
    this.alive = false;
    this.onDestroy$.next();
  }
}
